import { render, staticRenderFns } from "./DeletedSalesBrowse.vue?vue&type=template&id=fb828220&scoped=true"
import script from "./DeletedSalesBrowse.vue?vue&type=script&lang=ts"
export * from "./DeletedSalesBrowse.vue?vue&type=script&lang=ts"
import style0 from "./DeletedSalesBrowse.vue?vue&type=style&index=0&id=fb828220&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb828220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb828220')) {
      api.createRecord('fb828220', component.options)
    } else {
      api.reload('fb828220', component.options)
    }
    module.hot.accept("./DeletedSalesBrowse.vue?vue&type=template&id=fb828220&scoped=true", function () {
      api.rerender('fb828220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/DeletedSalesBrowse.vue"
export default component.exports